import { render, staticRenderFns } from "./first.vue?vue&type=template&id=48445c8d&scoped=true&"
import script from "./first.vue?vue&type=script&lang=js&"
export * from "./first.vue?vue&type=script&lang=js&"
import style0 from "./first.vue?vue&type=style&index=0&id=48445c8d&prod&scoped=true&lang=less&"
import style1 from "./first.vue?vue&type=style&index=1&id=48445c8d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48445c8d",
  null
  
)

export default component.exports